import { useTranslation } from 'react-i18next'

import QrCode from '@shared/ui/qrcode/QrCode'
import { formatDayMonth } from '@shared/uttils/formatDayMonth'

import styles from './QrModal.module.scss'

interface QrModalProps {
  title: string;
  description?: string;
  validTo?: string;
  qrCode: string;
}

export default function QrModal ({ title, description, validTo, qrCode }: QrModalProps) {
  const { t: tc } = useTranslation('common')

  return (
    <div className={styles.qrModal}>
      <div className={styles.qrModal__header}>
        <div>
          <h3 className={styles.qrModal__title}>{title}</h3>
          { validTo && (
            <p className={styles.qrModal__date}>
              {tc('up_to')} {formatDayMonth(validTo)}
            </p>
          )}
        </div>
      </div>
      
      <div className={styles.qrModal__content}>
        <QrCode 
          value={qrCode} 
          size={220}
          className={styles.qrModal__qr}
        />
        <div className={styles.qrModal__code}>
          {qrCode}
        </div>
      </div>

      {description && (
        <p className={styles.qrModal__description}>{description}</p>
      )}
    </div>
  )
}